var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletenormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#232323",
    stroke: "#404040"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_33",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 27.5C15.3749 27.5 14.9826 27.3368 14.6562 27.0104C14.3298 26.684 14.1666 26.2917 14.1666 25.8333V15H13.3333V13.3333H17.4999V12.5H22.4999V13.3333H26.6666V15H25.8333V25.8333C25.8333 26.2917 25.6701 26.684 25.3437 27.0104C25.0173 27.3368 24.6249 27.5 24.1666 27.5H15.8333ZM24.1666 15H15.8333V25.8333H24.1666V15ZM17.4999 24.1667H19.1666V16.6667H17.4999V24.1667ZM20.8333 24.1667H22.4999V16.6667H20.8333V24.1667Z",
    fill: "#969696"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletenormal);
export default __webpack_public_path__ + "static/media/deletenormal.1c67d0445bbd164a24a261b1b4b0efc2.svg";
export { ForwardRef as ReactComponent };